import { defineMessages } from 'react-intl';

const messages = defineMessages({
  searchPageTitle: {
    id: 'Search page title',
    defaultMessage: 'Cerca',
  },
  searchResultsTitle: {
    id: 'Search results title',
    defaultMessage: 'Resultats de cerca',
  },
  searchResultsForTerm: {
    id: 'Search results for term',
    defaultMessage: 'Resultats de cerca per {term}',
  },
  whatDoYouWantToSearch: {
    id: 'What do you want to search',
    defaultMessage: 'Què vols cercar?',
  },
  searchPlaceholderUppercase: {
    id: 'Search placeholder uppercase',
    defaultMessage: 'CERCAR',
  },
  readMoreEllipsis: {
    id: 'Read more ellipsis',
    defaultMessage: 'Llegir més...',
  },
});

export default messages;
